import React, { useState, useMemo, useCallback } from "react";
import { Button } from "@ufginsurance/ui-kit";
import PreQuoteModal from "../../../online-quoting/step1/PreQuoteModal";
import * as routes from "../../../constants/routes";
import { clearLocalQuoteManually } from "../../../online-quoting/shared/util";
import { useHistory } from "react-router-dom";
import { Translations } from "../../translations";

export const useNewQuoteButton = () => {
  const history = useHistory();

  const [showPreQuoteModal, setShowPreQuoteModal] = useState(false);

  const { actions } = Translations.commercial.new_submissions_tab;

  const handleAddNewQuote = useCallback(() => {
    clearLocalQuoteManually();
    history.push(routes.ONLINE_QUOTING_STEP1);
  }, [history]);

  const NewQuoteButton = useCallback(() => {
    return (
      <div className="commercial-new-quote">
        <Button onClick={() => setShowPreQuoteModal(true)} variant="primary">
          {actions.newQuote}
        </Button>
      </div>
    );
  }, [actions.newQuote]);

  const QuotingModal = useCallback(() => {
    if (showPreQuoteModal) {
      return (
        <PreQuoteModal
          history={history}
          onContinue={handleAddNewQuote}
          showPreQuoteModal={showPreQuoteModal}
          setShowPreQuoteModal={setShowPreQuoteModal}
        />
      );
    }
    return null;
  }, [handleAddNewQuote, history, showPreQuoteModal]);

  return useMemo(
    () => ({
      NewQuoteButton,
      QuotingModal
    }),
    [NewQuoteButton, QuotingModal]
  );
};
